export { default } from './TopSpots';
